const openPepedrive = function () {
  try {
    LeadBooster.trigger("open");
  } catch (Exception) {
    console.warn("Exception in openPepedrive => " + Exception);
  }
};

window.getQuote = function (event, title = "") {
  try {
    event.preventDefault();
    let label = title.replaceAll(" ", "-").toLocaleLowerCase();
    try {
      gtag("event", "contact", {
        event_category: "quicksearch",
        event_label: label,
      });
    } catch (Exception) {
      console.warn("Exception in gtag => " + Exception);
    }
    if (jivo_api === undefined) return openPepedrive();
    let status = jivo_api.chatMode();
    if (status == "offline") return openPepedrive();
    jivo_api.sendMessage(
      `Hola, me interesa cotizar el siguiente producto: ${title}.`
    );
    return jivo_api.open();
  } catch (Ex) {
    console.warn("Exception in getQuote => " + Ex);
  }
};

window.notResults = function (event) {
  try {
    event.preventDefault();
    if (jivo_api === undefined) return openPepedrive();
    let status = jivo_api.chatMode();
    if (status == "offline") return openPepedrive();
    return jivo_api.open();
  } catch (Exception) {
    console.warn("Exception in notResults => " + Exception);
  }
};
